document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.partnership-form');
  const partnerTabs = document.querySelectorAll('[data-partner-tab]');
  const partnershipHeaderCopies = document.querySelectorAll('[data-partnership-copy]');
  let isPartnershipSubmitting = false;
  let hasTrackedPartnershipFormStart = false;
  let suppressNextPartnerTabTrack = false;
  const pendingPartnershipClarityCalls = [];
  let partnershipClarityFlushTimer = null;

  function flushPartnershipClarityCalls() {
    if (typeof window.clarity !== 'function') {
      partnershipClarityFlushTimer = window.setTimeout(flushPartnershipClarityCalls, 500);
      return;
    }
    partnershipClarityFlushTimer = null;
    while (pendingPartnershipClarityCalls.length) {
      const args = pendingPartnershipClarityCalls.shift();
      try {
        window.clarity.apply(window, args);
      } catch (error) {}
    }
  }

  function callPartnershipClarity(method, key, value) {
    const args = arguments.length >= 3 ? [method, key, value] : [method, key];
    if (typeof window.clarity !== 'function') {
      pendingPartnershipClarityCalls.push(args);
      if (partnershipClarityFlushTimer === null) {
        partnershipClarityFlushTimer = window.setTimeout(flushPartnershipClarityCalls, 500);
      }
      return;
    }
    try {
      window.clarity.apply(window, args);
    } catch (error) {}
  }

  function trackPartnershipClarityEvent(eventName, failureType) {
    if (!eventName) return;
    const selectedCategory = partnershipCategorySelector?.getSelected() || activeFormCategory || getActivePartnerCategory();
    callPartnershipClarity('set', 'partnership_category', selectedCategory);
    callPartnershipClarity('set', 'partnership_failure_type', failureType || 'none');
    callPartnershipClarity('event', eventName);
  }

  function trackPartnershipFormStart() {
    if (hasTrackedPartnershipFormStart) return;
    hasTrackedPartnershipFormStart = true;
    trackPartnershipClarityEvent('start_partnership_form');
  }

  function normalizeClarityValue(value) {
    if (Array.isArray(value)) {
      value = value.filter(Boolean).join(', ');
    }
    return String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 120) || 'none';
  }

  function getElementTextValue(element) {
    if (!element) return '';
    return normalizeClarityValue(element.textContent || element.getAttribute('aria-label') || '');
  }

  function trackPartnershipInteraction(eventName, interactionType, interactionLabel, interactionSection, interactionCategory) {
    if (!eventName) return;
    const selectedCategory = interactionCategory || partnershipCategorySelector?.getSelected() || activeFormCategory || getActivePartnerCategory();
    callPartnershipClarity('set', 'partnership_category', normalizeClarityValue(selectedCategory));
    callPartnershipClarity('set', 'partnership_interaction_type', normalizeClarityValue(interactionType));
    callPartnershipClarity('set', 'partnership_interaction_label', normalizeClarityValue(interactionLabel));
    callPartnershipClarity('set', 'partnership_interaction_section', normalizeClarityValue(interactionSection));
    callPartnershipClarity('event', eventName);
  }

  function getActivePartnerCategory() {
    return document.querySelector('[data-partner-tab].partner-with-us__tab--active')?.dataset.partnerTab || 'RESELLER';
  }

  function syncPartnerTabs(category) {
    partnerTabs.forEach(function (tab) {
      const isActive = tab.dataset.partnerTab === category;
      tab.classList.toggle('partner-with-us__tab--active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });
  }

  function updatePartnershipHeader(category) {
    if (!partnershipHeaderCopies.length) return;

    let hasMatchingCopy = false;
    partnershipHeaderCopies.forEach(function (copy) {
      const isActive = copy.dataset.partnershipCopy === category;
      copy.hidden = !isActive;
      if (isActive) hasMatchingCopy = true;
    });

    if (!hasMatchingCopy) {
      partnershipHeaderCopies[0].hidden = false;
    }
  }

  document.querySelectorAll('.partner-with-us__link[data-partnership-category]').forEach(function(link) {
    link.addEventListener('click', function() {
      const targetCategory = link.dataset.partnershipCategory;
      trackPartnershipInteraction(
        'partnership_click_partner_cta',
        'cta_link',
        getElementTextValue(link) + ' | ' + normalizeClarityValue(targetCategory),
        'partner_with_us_intro',
        targetCategory
      );
      const targetTab = Array.from(partnerTabs).find(function(tab) {
        return tab.dataset.partnerTab === targetCategory;
      });
      if (targetTab) {
        suppressNextPartnerTabTrack = true;
        targetTab.click();
      } else {
        syncPartnerTabs(targetCategory);
        updatePartnershipHeader(targetCategory);
        document.dispatchEvent(new CustomEvent('partnerCategoryChange', { detail: { category: targetCategory } }));
      }
    });
  });

  partnerTabs.forEach(function(tab) {
    if (tab.dataset.partnershipClarityBound === 'true') return;
    tab.dataset.partnershipClarityBound = 'true';
    tab.addEventListener('click', function() {
      if (suppressNextPartnerTabTrack) {
        suppressNextPartnerTabTrack = false;
        return;
      }
      trackPartnershipInteraction(
        'partnership_click_partner_tab',
        'tab',
        getElementTextValue(tab) || normalizeClarityValue(tab.dataset.partnerTab),
        'partner_with_us_intro',
        tab.dataset.partnerTab
      );
    });
  });

  updatePartnershipHeader(getActivePartnerCategory());

  const validationMessages = window.frontendMessages || {};
  const submitTrigger = form
    ? form.querySelector('.partnership-form__submit button, .partnership-form__submit [type="submit"], .partnership-form__submit')
    : null;
  const submitButton = form
    ? form.querySelector('.partnership-form__submit button, .partnership-form__submit[type="submit"], .partnership-form__submit')
    : null;
  const loadingLabel = (window.PartnershipI18n && window.PartnershipI18n.loadingLabel) || 'Loading...';
  let isManualSubmitInProgress = false;

  function setSubmitButtonLoading(isLoading) {
    if (!submitButton) return;
    const labelEl = submitButton.querySelector('.component-cta-button__label');
    if (!submitButton.hasAttribute('data-default-label')) {
      submitButton.setAttribute('data-default-label', labelEl ? labelEl.textContent : '');
    }
    const defaultLabel = submitButton.getAttribute('data-default-label') || '';
    submitButton.disabled = !!isLoading;
    submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    submitButton.classList.toggle('is-loading', !!isLoading);
    submitButton.classList.toggle('component-cta-button--disabled', !!isLoading);
    if (labelEl) {
      labelEl.textContent = isLoading ? loadingLabel : defaultLabel;
    }
  }

  if (form) {
    form.addEventListener('focusin', trackPartnershipFormStart, { once: true });
    form.addEventListener('input', trackPartnershipFormStart, { once: true });
    form.addEventListener('change', trackPartnershipFormStart, { once: true });
  }

  if (submitTrigger) {
    const triggerManualSubmit = function (event) {
      if (isManualSubmitInProgress) {
        return;
      }

      trackPartnershipInteraction(
        'partnership_click_submit',
        'submit_button',
        getElementTextValue(submitButton) || 'Submit',
        'partnership_form'
      );

      event.preventDefault();
      if (typeof event.stopPropagation === 'function') {
        event.stopPropagation();
      }
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      isManualSubmitInProgress = true;

      const activeElement = document.activeElement;
      if (activeElement && form.contains(activeElement) && typeof activeElement.blur === 'function') {
        activeElement.blur();
      }

      setTimeout(function () {
        try {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(
              submitButton && submitButton.getAttribute('type') === 'submit'
                ? submitButton
                : undefined
            );
          } else {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        } finally {
          setTimeout(function () {
            isManualSubmitInProgress = false;
          }, 0);
        }
      }, 0);
    };

    submitTrigger.addEventListener('pointerdown', function (event) {
      triggerManualSubmit(event);
    }, true);

    submitTrigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        triggerManualSubmit(event);
      }
    }, true);
  }
  
  // 获取条件字段容器
  const partnershipSubcategoryField = document.getElementById('partnershipSubcategoryField');
  const resellerSpecificFields = document.getElementById('resellerSpecificFields');
  const resellerBasicFields = document.getElementById('resellerBasicFields');

  // Other Information：Enterprise 分类时移动到 Email 下方，其余分类留在 Basic Information
  const otherInformationField = document.getElementById('otherInformationField');
  const emailFieldRow = form ? form.querySelector('.partnership-form__email')?.closest('.partnership-form__row') : null;

  function positionOtherInformationForCategory(selectedValue) {
    if (!otherInformationField || !emailFieldRow) return;
    const basicInfoSection = resellerBasicFields ? resellerBasicFields.closest('.partnership-form__section') : null;
    const isEnterpriseCategory = String(selectedValue || '').trim() === 'ENTERPRISE_SOLUTION';
    if (isEnterpriseCategory) {
      // Enterprise：Other Information 移到 Email 下方，同时隐藏整个 Basic Information 段落
      emailFieldRow.parentNode.insertBefore(otherInformationField, emailFieldRow.nextSibling);
      if (basicInfoSection) basicInfoSection.style.display = 'none';
    } else {
      if (basicInfoSection) {
        basicInfoSection.appendChild(otherInformationField);
        basicInfoSection.style.display = '';
      }
    }
  }
  const partnershipI18n = window.PartnershipI18n || {};
  
  // 选择器实例
  let continentSelector = null;
  let countryStateSelector = null;
  let partnershipCategorySelector = null;
  let partnershipSubcategorySelector = null;
  let industriesSelector = null;
  const tabFormStates = Object.create(null);
  let initialTabFormState = null;
  let activeFormCategory = getActivePartnerCategory();
  let tabRestoreVersion = 0;
  let isRestoringTabState = false;
  
  // Continent 选项
  const defaultContinentOptions = [
    { value: 'Africa', label: 'Africa' },
    { value: 'Asia', label: 'Asia' },
    { value: 'Europe', label: 'Europe' },
    { value: 'North America', label: 'North America' },
    { value: 'South America', label: 'South America' },
    { value: 'Oceania', label: 'Oceania' }
  ];
  const continentOptions = Array.isArray(partnershipI18n.continents) && partnershipI18n.continents.length
    ? partnershipI18n.continents
    : defaultContinentOptions;
  
  // Country/State 选项 (无需修改，动态生成时 value=name)
  const countryStateOptions = [
    { value: 'United States', label: 'United States' },
    { value: 'China', label: 'China' },
    { value: 'United Kingdom', label: 'United Kingdom' },
    { value: 'Japan', label: 'Japan' },
    { value: 'South Korea', label: 'South Korea' },
    { value: 'Australia', label: 'Australia' }
  ];
  
  const PARTNERSHIP_FORM_CODE = 'partnership';

  // Partnership Category 选项（一级选项）
  const defaultPartnershipCategoryDefinitions = [
    {
      value: 'RESELLER',
      label: (partnershipI18n.categories || [])[0]?.label || 'Reseller',
      children: [
        { value: 'DEALER', label: (partnershipI18n.subcategories?.RESELLER || [])[0]?.label || 'Dealer' },
        { value: 'DISTRIBUTOR', label: (partnershipI18n.subcategories?.RESELLER || [])[1]?.label || 'Distributor' }
      ]
    },
    {
      value: 'ENTERPRISE_SOLUTION',
      label: (partnershipI18n.categories || [])[1]?.label || 'Enterprise Solution',
      children: [
        { value: 'FOUNDATION_ASSOCIATION', label: (partnershipI18n.subcategories?.ENTERPRISE_SOLUTION || [])[0]?.label || 'Foundation & Association' },
        { value: 'CARE_CENTER', label: (partnershipI18n.subcategories?.ENTERPRISE_SOLUTION || [])[1]?.label || 'Care Center' },
        { value: 'THEME_PARK_RESORT', label: (partnershipI18n.subcategories?.ENTERPRISE_SOLUTION || [])[2]?.label || 'Theme Park & Resort' },
        { value: 'HOSPITAL', label: (partnershipI18n.subcategories?.ENTERPRISE_SOLUTION || [])[3]?.label || 'Hospital' },
        { value: 'AIRPORT', label: (partnershipI18n.subcategories?.ENTERPRISE_SOLUTION || [])[4]?.label || 'Airport' },
        { value: 'HOTEL_CASINO', label: (partnershipI18n.subcategories?.ENTERPRISE_SOLUTION || [])[5]?.label || 'Hotel & Casino' },
        { value: 'CONVENTION_CENTER', label: (partnershipI18n.subcategories?.ENTERPRISE_SOLUTION || [])[6]?.label || 'Convention Center' },
        { value: 'ENTERPRISE_OTHERS', label: (partnershipI18n.subcategories?.ENTERPRISE_SOLUTION || [])[7]?.label || 'Others' }
      ]
    },
    {
      value: 'MARKETING',
      label: (partnershipI18n.categories || [])[2]?.label || 'Marketing',
      children: [
        { value: 'MEDIA', label: (partnershipI18n.subcategories?.MARKETING || [])[0]?.label || 'Media' },
        { value: 'KOL', label: (partnershipI18n.subcategories?.MARKETING || [])[1]?.label || 'KOL' },
        { value: 'EVENTS', label: (partnershipI18n.subcategories?.MARKETING || [])[2]?.label || 'Events' },
        { value: 'CONTENT_CREATOR', label: (partnershipI18n.subcategories?.MARKETING || [])[3]?.label || 'Content Creator' }
      ]
    },
    {
      value: 'SUPPLIER',
      label: (partnershipI18n.categories || [])[3]?.label || 'Supplier',
      children: [
        { value: 'MATERIALS_EQUIPMENT', label: (partnershipI18n.subcategories?.SUPPLIER || [])[0]?.label || 'Materials & Equipment' },
        { value: 'SERVICES', label: (partnershipI18n.subcategories?.SUPPLIER || [])[1]?.label || 'Services' }
      ]
    },
    {
      value: 'OTHERS',
      label: (partnershipI18n.categories || [])[4]?.label || 'Others',
      children: []
    }
  ];
  let partnershipCategoryDefinitions = defaultPartnershipCategoryDefinitions.map(function (category) {
    return {
      value: category.value,
      label: category.label,
      children: Array.isArray(category.children) ? category.children.slice() : []
    };
  });
  let partnershipCategoryOptions = partnershipCategoryDefinitions.map(function (category) {
    return { value: category.value, label: category.label };
  });
  let partnershipSubcategoryOptions = {};
  
  const defaultHearAboutUsOptions = Array.isArray(partnershipI18n.hearAboutUs) && partnershipI18n.hearAboutUs.length
    ? partnershipI18n.hearAboutUs
    : [
      { value: 'EXHIBITION_EVENTS', label: 'Exhibition/Events' },
      { value: 'INSTAGRAM', label: 'Instagram' },
      { value: 'GOOGLE', label: 'Google' },
      { value: 'REFERRED_BY_OTHERS', label: 'Referred by others' },
      { value: 'FACEBOOK', label: 'Facebook' },
      { value: 'YOUTUBE', label: 'Youtube' },
      { value: 'MEDIA_REPORT', label: 'Media report' },
      { value: 'OTHER', label: 'Others' }
    ];
  let hearAboutUsOptions = defaultHearAboutUsOptions.slice();

  let yesNoOptions = Array.isArray(partnershipI18n.yesNo) && partnershipI18n.yesNo.length
    ? partnershipI18n.yesNo.slice()
    : [
      { value: 'YES', label: 'Yes' },
      { value: 'NO', label: 'No' }
    ];
  
  // Industries 选项
  const defaultIndustriesOptions = [
    { value: 'Mobility', label: 'Mobility' },
    { value: 'Medical', label: 'Medical' },
    { value: 'CE (Consumer Electronics)', label: 'CE (Consumer Electronics)' },
    { value: 'Overall', label: 'Overall' },
    { value: 'Others', label: 'Others' }
  ];
  const industriesOptions = Array.isArray(partnershipI18n.industries) && partnershipI18n.industries.length
    ? partnershipI18n.industries
    : defaultIndustriesOptions;

  // 国家名称到 ISO2 代码的映射表（用于 zip code 验证）
  const countryNameToISO2 = {
    'Afghanistan': 'AF', 'Albania': 'AL', 'Algeria': 'DZ', 'Andorra': 'AD', 'Angola': 'AO',
    'Anguilla': 'AI', 'Antarctica': 'AQ', 'Antigua and Barbuda': 'AG', 'Argentina': 'AR',
    'Armenia': 'AM', 'Aruba': 'AW', 'Australia': 'AU', 'Austria': 'AT', 'Azerbaijan': 'AZ',
    'Bahamas': 'BS', 'Bahrain': 'BH', 'Bangladesh': 'BD', 'Barbados': 'BB', 'Belarus': 'BY',
    'Belgium': 'BE', 'Belize': 'BZ', 'Benin': 'BJ', 'Bermuda': 'BM', 'Bhutan': 'BT',
    'Bolivia': 'BO', 'Bosnia and Herzegovina': 'BA', 'Botswana': 'BW', 'Brazil': 'BR',
    'British Indian Ocean Territory': 'IO', 'British Virgin Islands': 'VG', 'Brunei': 'BN',
    'Bulgaria': 'BG', 'Burkina Faso': 'BF', 'Burundi': 'BI', 'Cabo Verde': 'CV',
    'Cambodia': 'KH', 'Cameroon': 'CM', 'Canada': 'CA', 'Caribbean Netherlands': 'BQ',
    'Cayman Islands': 'KY', 'Central African Republic': 'CF', 'Chad': 'TD', 'Chile': 'CL',
    'China': 'CN', 'Christmas Island': 'CX', 'Cocos (Keeling) Islands': 'CC', 'Colombia': 'CO',
    'Comoros': 'KM', 'Congo': 'CG', 'Costa Rica': 'CR', 'Côte d\'Ivoire': 'CI',
    'Croatia': 'HR', 'Cuba': 'CU', 'Curaçao': 'CW', 'Cyprus': 'CY', 'Czech Republic': 'CZ',
    'Democratic Republic of the Congo': 'CD', 'Denmark': 'DK', 'Djibouti': 'DJ', 'Dominica': 'DM',
    'Dominican Republic': 'DO', 'East Timor (Timor-Leste)': 'TL', 'Ecuador': 'EC', 'Egypt': 'EG',
    'El Salvador': 'SV', 'Equatorial Guinea': 'GQ', 'Eritrea': 'ER', 'Estonia': 'EE',
    'Ethiopia': 'ET', 'Falkland Islands (Malvinas)': 'FK', 'Faroe Islands': 'FO', 'Fiji': 'FJ',
    'Finland': 'FI', 'France': 'FR', 'French Guiana': 'GF', 'French Polynesia': 'PF',
    'French Southern Territories': 'TF', 'Gabon': 'GA', 'Gambia': 'GM', 'Georgia': 'GE',
    'Germany': 'DE', 'Ghana': 'GH', 'Gibraltar': 'GI', 'Greece': 'GR', 'Greenland': 'GL',
    'Grenada': 'GD', 'Guadeloupe': 'GP', 'Guam': 'GU', 'Guatemala': 'GT', 'Guernsey': 'GG',
    'Guinea': 'GN', 'Guinea-Bissau': 'GW', 'Guyana': 'GY', 'Haiti': 'HT', 'Honduras': 'HN',
    'Hong Kong, China': 'HK', 'Hungary': 'HU', 'Iceland': 'IS', 'India': 'IN', 'Indonesia': 'ID',
    'Iran': 'IR', 'Iraq': 'IQ', 'Ireland': 'IE', 'Isle of Man': 'IM', 'Israel': 'IL',
    'Italy': 'IT', 'Jamaica': 'JM', 'Japan': 'JP', 'Jersey': 'JE', 'Jordan': 'JO',
    'Kazakhstan': 'KZ', 'Kenya': 'KE', 'Kiribati': 'KI', 'Kuwait': 'KW', 'Kyrgyzstan': 'KG',
    'Laos': 'LA', 'Latvia': 'LV', 'Lebanon': 'LB', 'Lesotho': 'LS', 'Liberia': 'LR',
    'Libya': 'LY', 'Liechtenstein': 'LI', 'Lithuania': 'LT', 'Luxembourg': 'LU',
    'Macau, China': 'MO', 'North Macedonia': 'MK', 'Madagascar': 'MG', 'Malawi': 'MW',
    'Malaysia': 'MY', 'Maldives': 'MV', 'Mali': 'ML', 'Malta': 'MT', 'Marshall Islands': 'MH',
    'Martinique': 'MQ', 'Mauritania': 'MR', 'Mauritius': 'MU', 'Mayotte': 'YT', 'Mexico': 'MX',
    'Micronesia (Federated States of)': 'FM', 'Moldova': 'MD', 'Monaco': 'MC', 'Mongolia': 'MN',
    'Montenegro': 'ME', 'Montserrat': 'MS', 'Morocco': 'MA', 'Mozambique': 'MZ', 'Myanmar': 'MM',
    'Namibia': 'NA', 'Nauru': 'NR', 'Nepal': 'NP', 'Netherlands': 'NL', 'New Caledonia': 'NC',
    'New Zealand': 'NZ', 'Nicaragua': 'NI', 'Niger': 'NE', 'Nigeria': 'NG', 'Niue': 'NU',
    'Norfolk Island': 'NF', 'North Korea': 'KP', 'Northern Mariana Islands': 'MP', 'Norway': 'NO',
    'Oman': 'OM', 'Pakistan': 'PK', 'Palau': 'PW', 'Palestine': 'PS', 'Panama': 'PA',
    'Papua New Guinea': 'PG', 'Paraguay': 'PY', 'Peru': 'PE', 'Philippines': 'PH',
    'Pitcairn Islands': 'PN', 'Poland': 'PL', 'Portugal': 'PT', 'Puerto Rico': 'PR',
    'Qatar': 'QA', 'Republic of the Congo': 'CG', 'Réunion': 'RE', 'Romania': 'RO',
    'Russia': 'RU', 'Rwanda': 'RW', 'Saint Barthélemy': 'BL', 'Saint Helena': 'SH',
    'Saint Kitts and Nevis': 'KN', 'Saint Lucia': 'LC', 'Saint Martin (French part)': 'MF',
    'Saint Pierre and Miquelon': 'PM', 'Saint Vincent and the Grenadines': 'VC',
    'Samoa': 'WS', 'San Marino': 'SM', 'São Tomé and Príncipe': 'ST', 'Saudi Arabia': 'SA',
    'Senegal': 'SN', 'Serbia': 'RS', 'Seychelles': 'SC', 'Sierra Leone': 'SL', 'Singapore': 'SG',
    'Sint Maarten (Dutch part)': 'SX', 'Slovakia': 'SK', 'Slovenia': 'SI', 'Solomon Islands': 'SB',
    'Somalia': 'SO', 'South Africa': 'ZA', 'South Georgia and the South Sandwich Islands': 'GS',
    'South Korea': 'KR', 'South Sudan': 'SS', 'Spain': 'ES', 'Sri Lanka': 'LK',
    'Sudan': 'SD', 'Suriname': 'SR', 'Svalbard and Jan Mayen': 'SJ', 'Sweden': 'SE',
    'Switzerland': 'CH', 'Syria': 'SY', 'Taiwan, China': 'TW', 'Tajikistan': 'TJ', 'Tanzania': 'TZ',
    'Thailand': 'TH', 'Timor-Leste': 'TL', 'Togo': 'TG', 'Tokelau': 'TK', 'Tonga': 'TO',
    'Trinidad and Tobago': 'TT', 'Tunisia': 'TN', 'Turkey': 'TR', 'Turkmenistan': 'TM',
    'Turks and Caicos Islands': 'TC', 'Tuvalu': 'TV', 'Uganda': 'UG', 'Ukraine': 'UA',
    'United Arab Emirates': 'AE', 'United Kingdom': 'GB', 'United States': 'US',
    'United States Minor Outlying Islands': 'UM', 'U.S. Virgin Islands': 'VI', 'Uruguay': 'UY',
    'Uzbekistan': 'UZ', 'Vanuatu': 'VU', 'Vatican City': 'VA', 'Venezuela': 'VE', 'Vietnam': 'VN',
    'Wallis and Futuna': 'WF', 'Western Sahara': 'EH', 'Yemen': 'YE', 'Zambia': 'ZM', 'Zimbabwe': 'ZW',
    'Åland Islands': 'AX', 'Eswatini': 'SZ', 'Heard Island and McDonald Islands': 'HM'
  };

  function getCountryDisplayLocale() {
    const rawLocale = String(
      (window.Shopify && window.Shopify.locale) ||
      (document.documentElement && document.documentElement.lang) ||
      'en'
    ).trim();
    const lowerLocale = rawLocale.toLowerCase();

    if (lowerLocale === 'zh-cn') return 'zh-CN';
    if (lowerLocale === 'zh-tw') return 'zh-TW';
    if (lowerLocale.startsWith('zh')) return lowerLocale.includes('tw') ? 'zh-TW' : 'zh-CN';
    if (lowerLocale.startsWith('de')) return 'de';
    if (lowerLocale.startsWith('fr')) return 'fr';
    if (lowerLocale.startsWith('it')) return 'it';
    if (lowerLocale.startsWith('nl')) return 'nl';
    if (lowerLocale.startsWith('es')) return 'es';
    if (lowerLocale.startsWith('ja')) return 'ja';
    if (lowerLocale.startsWith('ko')) return 'ko';
    if (lowerLocale.startsWith('th')) return 'th';
    return 'en';
  }

  function getLocalizedCountryLabel(countryName) {
    const code = String(countryNameToISO2[countryName] || '').toUpperCase();
    if (!code) return countryName;

    const locale = getCountryDisplayLocale();
    if (window.CountryDisplayUtils && typeof window.CountryDisplayUtils.getLocalizedCountryName === 'function') {
      return window.CountryDisplayUtils.getLocalizedCountryName(code, locale, countryName);
    }

    const specialNames = {
      HK: { en: 'Hong Kong (China)', 'zh-CN': '中国香港', 'zh-TW': '中國香港' },
      TW: { en: 'Taiwan (China)', 'zh-CN': '中国台湾', 'zh-TW': '中國台灣' },
      MO: { en: 'Macao (China)', 'zh-CN': '中国澳门', 'zh-TW': '中國澳門' }
    };

    if (specialNames[code]) {
      return specialNames[code][locale] || specialNames[code].en || countryName;
    }

    if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
      try {
        const displayNames = new Intl.DisplayNames([locale, 'en'], { type: 'region' });
        const localizedName = displayNames.of(code);
        if (localizedName && localizedName !== code) {
          return localizedName;
        }
      } catch (error) {}
    }

    return countryName;
  }

  function buildSubcategoryOptionsMap(categoryDefinitions) {
    return (Array.isArray(categoryDefinitions) ? categoryDefinitions : []).reduce(function (acc, category) {
      acc[category.value] = Array.isArray(category.children)
        ? category.children.filter(function (child) {
                  return child.value !== 'SALES_REPRESENTATIVE';
                }).map(function (child) {
          return { value: child.value, label: child.label };
        })
        : [];
      return acc;
    }, {});
  }

  function setPartnershipCategoryDefinitions(nextDefinitions) {
    partnershipCategoryDefinitions = Array.isArray(nextDefinitions)
      ? nextDefinitions.map(function (category) {
          return {
            value: category.value,
            label: category.label,
            children: Array.isArray(category.children)
              ? category.children.filter(function (child) {
                  return child.value !== 'SALES_REPRESENTATIVE';
                }).map(function (child) {
                  return { value: child.value, label: child.label };
                })
              : []
          };
        })
      : [];
    partnershipCategoryOptions = partnershipCategoryDefinitions.map(function (category) {
      return { value: category.value, label: category.label };
    });
    partnershipSubcategoryOptions = buildSubcategoryOptionsMap(partnershipCategoryDefinitions);
  }

  function normalizePartnershipFieldOptions(optionList) {
    if (!Array.isArray(optionList)) return [];
    return optionList
      .slice()
      .sort(function (a, b) {
        const aOrder = Number(a && a.sortOrder);
        const bOrder = Number(b && b.sortOrder);
        if (Number.isFinite(aOrder) && Number.isFinite(bOrder) && aOrder !== bOrder) {
          return aOrder - bOrder;
        }
        return 0;
      })
      .map(function (item) {
        const value = String((item && (item.code || item.value || item.label)) || '').trim();
        const label = String((item && (item.label || item.code || item.value)) || '').trim();
        if (!value || !label) return null;
        return {
          value: value,
          label: label,
          children: normalizePartnershipFieldOptions(item && item.children)
        };
      })
      .filter(Boolean);
  }

  function fetchPartnershipFieldOptions() {
    const apiBase = String(window.API_BASE_URL || '').replace(/\/$/, '');
    const requestUrl = apiBase
      ? `${apiBase}/user/channel/form-options?formCode=${encodeURIComponent(PARTNERSHIP_FORM_CODE)}`
      : `/user/channel/form-options?formCode=${encodeURIComponent(PARTNERSHIP_FORM_CODE)}`;

    return fetch(requestUrl, {
      method: 'GET',
      headers: {
        'X-Client-Type': 'web'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Fetch partnership field options failed');
        }
        return response.json().catch(function () { return null; });
      })
      .then(function (result) {
        const fieldOptions = result && result.data && result.data.fieldOptions ? result.data.fieldOptions : null;
        if (!result || Number(result.code) !== 200 || !fieldOptions) {
          throw new Error('Invalid partnership field options response');
        }

        return {
          categoryDefinitions: normalizePartnershipFieldOptions(fieldOptions.partnership_first_category),
          hearAboutUsOptions: normalizePartnershipFieldOptions(fieldOptions.hear_about_us).map(function (item) {
            return { value: item.value, label: item.label };
          }),
          yesNoOptions: normalizePartnershipFieldOptions(fieldOptions.yes_no).map(function (item) {
            return { value: item.value, label: item.label };
          })
        };
      });
  }

  function normalizeComparisonValue(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[_\s-]+/g, '');
  }

  function isAffirmativeValue(value) {
    const normalized = normalizeComparisonValue(value);
    return normalized === 'yes' || normalized === 'true' || normalized === '1';
  }

  function isResellerCategoryValue(value) {
    return normalizeComparisonValue(value) === 'reseller';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  setPartnershipCategoryDefinitions(partnershipCategoryDefinitions);

  if (form) {
    // 初始化 Continent 选择器
    const continentEl = document.getElementById('continent');
    if (continentEl && continentEl.selectorAPI) {
      continentSelector = continentEl.selectorAPI;
      continentSelector.setOptions(continentOptions);
      
      continentEl.addEventListener('selectorChanged', function(e) {
        const selectedContinent = e.detail.value;
        
        const fullData = [
          {
            "id": 1,
            "name": "Asia",
            "value": "asia",
            "countries": [
              { "id": 1, "name": "Afghanistan", "region_id": 1 },
              { "id": 2, "name": "Armenia", "region_id": 1 },
              { "id": 3, "name": "Azerbaijan", "region_id": 1 },
              { "id": 4, "name": "Bahrain", "region_id": 1 },
              { "id": 5, "name": "Bangladesh", "region_id": 1 },
              { "id": 6, "name": "Bhutan", "region_id": 1 },
              { "id": 7, "name": "British Indian Ocean Territory", "region_id": 1 },
              { "id": 8, "name": "Brunei", "region_id": 1 },
              { "id": 9, "name": "Cambodia", "region_id": 1 },
              { "id": 10, "name": "China", "region_id": 1 },
              { "id": 11, "name": "Christmas Island", "region_id": 1 },
              { "id": 12, "name": "Cocos (Keeling) Islands", "region_id": 1 },
              { "id": 13, "name": "Cyprus", "region_id": 1 },
              { "id": 14, "name": "East Timor (Timor-Leste)", "region_id": 1 },
              { "id": 15, "name": "Georgia", "region_id": 1 },
              { "id": 16, "name": "Hong Kong, China", "region_id": 1 },
              { "id": 17, "name": "India", "region_id": 1 },
              { "id": 18, "name": "Indonesia", "region_id": 1 },
              { "id": 19, "name": "Iran", "region_id": 1 },
              { "id": 20, "name": "Iraq", "region_id": 1 },
              { "id": 21, "name": "Israel", "region_id": 1 },
              { "id": 22, "name": "Japan", "region_id": 1 },
              { "id": 23, "name": "Jordan", "region_id": 1 },
              { "id": 24, "name": "Kazakhstan", "region_id": 1 },
              { "id": 25, "name": "Kuwait", "region_id": 1 },
              { "id": 26, "name": "Kyrgyzstan", "region_id": 1 },
              { "id": 27, "name": "Laos", "region_id": 1 },
              { "id": 28, "name": "Lebanon", "region_id": 1 },
              { "id": 29, "name": "Macau, China", "region_id": 1 },
              { "id": 30, "name": "Malaysia", "region_id": 1 },
              { "id": 31, "name": "Maldives", "region_id": 1 },
              { "id": 32, "name": "Mongolia", "region_id": 1 },
              { "id": 33, "name": "Myanmar", "region_id": 1 },
              { "id": 34, "name": "Nepal", "region_id": 1 },
              { "id": 35, "name": "North Korea", "region_id": 1 },
              { "id": 36, "name": "Oman", "region_id": 1 },
              { "id": 37, "name": "Pakistan", "region_id": 1 },
              { "id": 38, "name": "Palestine", "region_id": 1 },
              { "id": 39, "name": "Philippines", "region_id": 1 },
              { "id": 40, "name": "Qatar", "region_id": 1 },
              { "id": 41, "name": "Saudi Arabia", "region_id": 1 },
              { "id": 42, "name": "Singapore", "region_id": 1 },
              { "id": 43, "name": "South Korea", "region_id": 1 },
              { "id": 44, "name": "Sri Lanka", "region_id": 1 },
              { "id": 45, "name": "Syria", "region_id": 1 },
              { "id": 46, "name": "Taiwan, China", "region_id": 1 },
              { "id": 47, "name": "Tajikistan", "region_id": 1 },
              { "id": 48, "name": "Thailand", "region_id": 1 },
              { "id": 49, "name": "Turkmenistan", "region_id": 1 },
              { "id": 50, "name": "United Arab Emirates", "region_id": 1 },
              { "id": 51, "name": "Uzbekistan", "region_id": 1 },
              { "id": 52, "name": "Vietnam", "region_id": 1 },
              { "id": 53, "name": "Yemen", "region_id": 1 }
            ]
          },
          {
            "id": 2,
            "name": "South America",
            "value": "south-america",
            "countries": [
              { "id": 54, "name": "Argentina", "region_id": 2 },
              { "id": 55, "name": "Bolivia", "region_id": 2 },
              { "id": 56, "name": "Brazil", "region_id": 2 },
              { "id": 57, "name": "Caribbean Netherlands", "region_id": 2 },
              { "id": 58, "name": "Chile", "region_id": 2 },
              { "id": 59, "name": "Colombia", "region_id": 2 },
              { "id": 60, "name": "Curaçao", "region_id": 2 },
              { "id": 61, "name": "Ecuador", "region_id": 2 },
              { "id": 62, "name": "French Guiana", "region_id": 2 },
              { "id": 63, "name": "Guyana", "region_id": 2 },
              { "id": 64, "name": "Falkland Islands (Malvinas)", "region_id": 2 },
              { "id": 65, "name": "Paraguay", "region_id": 2 },
              { "id": 66, "name": "Peru", "region_id": 2 },
              { "id": 67, "name": "Suriname", "region_id": 2 },
              { "id": 68, "name": "Sint Maarten (Dutch part)", "region_id": 2 },
              { "id": 69, "name": "Uruguay", "region_id": 2 },
              { "id": 70, "name": "Venezuela", "region_id": 2 }
            ]
          },
          {
            "id": 3,
            "name": "Europe",
            "value": "europe",
            "countries": [
              { "id": 71, "name": "Albania", "region_id": 3 },
              { "id": 72, "name": "Andorra", "region_id": 3 },
              { "id": 73, "name": "Austria", "region_id": 3 },
              { "id": 74, "name": "Åland Islands", "region_id": 3 },
              { "id": 75, "name": "Belarus", "region_id": 3 },
              { "id": 76, "name": "Belgium", "region_id": 3 },
              { "id": 77, "name": "Bosnia and Herzegovina", "region_id": 3 },
              { "id": 78, "name": "Bulgaria", "region_id": 3 },
              { "id": 79, "name": "Canary Islands", "region_id": 3 },
              { "id": 80, "name": "Croatia", "region_id": 3 },
              { "id": 81, "name": "Czech Republic", "region_id": 3 },
              { "id": 82, "name": "Denmark", "region_id": 3 },
              { "id": 83, "name": "Estonia", "region_id": 3 },
              { "id": 84, "name": "Faroe Islands", "region_id": 3 },
              { "id": 85, "name": "Finland", "region_id": 3 },
              { "id": 86, "name": "France", "region_id": 3 },
              { "id": 87, "name": "Germany", "region_id": 3 },
              { "id": 88, "name": "Gibraltar", "region_id": 3 },
              { "id": 89, "name": "Greece", "region_id": 3 },
              { "id": 90, "name": "Guernsey", "region_id": 3 },
              { "id": 91, "name": "Hungary", "region_id": 3 },
              { "id": 92, "name": "Iceland", "region_id": 3 },
              { "id": 93, "name": "Ireland", "region_id": 3 },
              { "id": 94, "name": "Isle of Man", "region_id": 3 },
              { "id": 95, "name": "Italy", "region_id": 3 },
              { "id": 96, "name": "Jersey", "region_id": 3 },
              { "id": 97, "name": "Latvia", "region_id": 3 },
              { "id": 98, "name": "Liechtenstein", "region_id": 3 },
              { "id": 99, "name": "Lithuania", "region_id": 3 },
              { "id": 100, "name": "Luxembourg", "region_id": 3 },
              { "id": 101, "name": "North Macedonia", "region_id": 3 },
              { "id": 102, "name": "Malta", "region_id": 3 },
              { "id": 103, "name": "Moldova", "region_id": 3 },
              { "id": 104, "name": "Monaco", "region_id": 3 },
              { "id": 105, "name": "Montenegro", "region_id": 3 },
              { "id": 106, "name": "Netherlands", "region_id": 3 },
              { "id": 107, "name": "Norway", "region_id": 3 },
              { "id": 108, "name": "Poland", "region_id": 3 },
              { "id": 109, "name": "Portugal", "region_id": 3 },
              { "id": 110, "name": "Romania", "region_id": 3 },
              { "id": 248, "name": "Russia", "region_id": 3 },
              { "id": 111, "name": "San Marino", "region_id": 3 },
              { "id": 112, "name": "Serbia", "region_id": 3 },
              { "id": 113, "name": "Slovenia", "region_id": 3 },
              { "id": 114, "name": "Slovakia", "region_id": 3 },
              { "id": 115, "name": "Spain", "region_id": 3 },
              { "id": 116, "name": "Svalbard and Jan Mayen", "region_id": 3 },
              { "id": 117, "name": "Sweden", "region_id": 3 },
              { "id": 118, "name": "Switzerland", "region_id": 3 },
              { "id": 119, "name": "Turkey", "region_id": 3 },
              { "id": 249, "name": "Ukraine", "region_id": 3 },
              { "id": 120, "name": "United Kingdom", "region_id": 3 },
              { "id": 121, "name": "Vatican City", "region_id": 3 }
            ]
          },
          {
            "id": 4,
            "name": "Antarctica",
            "value": "antarctica",
            "countries": [
              { "id": 122, "name": "Antarctica", "region_id": 4 },
              { "id": 123, "name": "Bouvet Island", "region_id": 4 },
              { "id": 124, "name": "French Southern Territories", "region_id": 4 },
              { "id": 125, "name": "Heard Island and McDonald Islands", "region_id": 4 },
              { "id": 126, "name": "South Georgia and the South Sandwich Islands", "region_id": 4 }
            ]
          },
          {
            "id": 5,
            "name": "North America",
            "value": "north-america",
            "countries": [
              { "id": 127, "name": "Anguilla", "region_id": 5 },
              { "id": 128, "name": "Antigua and Barbuda", "region_id": 5 },
              { "id": 129, "name": "Aruba", "region_id": 5 },
              { "id": 130, "name": "Bahamas", "region_id": 5 },
              { "id": 131, "name": "Barbados", "region_id": 5 },
              { "id": 132, "name": "Belize", "region_id": 5 },
              { "id": 133, "name": "Bermuda", "region_id": 5 },
              { "id": 134, "name": "British Virgin Islands", "region_id": 5 },
              { "id": 135, "name": "Canada", "region_id": 5 },
              { "id": 136, "name": "Cayman Islands", "region_id": 5 },
              { "id": 137, "name": "Costa Rica", "region_id": 5 },
              { "id": 250, "name": "Cuba", "region_id": 5 },
              { "id": 138, "name": "Dominica", "region_id": 5 },
              { "id": 139, "name": "Dominican Republic", "region_id": 5 },
              { "id": 140, "name": "El Salvador", "region_id": 5 },
              { "id": 141, "name": "Grenada", "region_id": 5 },
              { "id": 142, "name": "Greenland", "region_id": 5 },
              { "id": 143, "name": "Guadeloupe", "region_id": 5 },
              { "id": 144, "name": "Guatemala", "region_id": 5 },
              { "id": 145, "name": "Haiti", "region_id": 5 },
              { "id": 146, "name": "Honduras", "region_id": 5 },
              { "id": 147, "name": "Jamaica", "region_id": 5 },
              { "id": 148, "name": "Martinique", "region_id": 5 },
              { "id": 149, "name": "Mexico", "region_id": 5 },
              { "id": 150, "name": "Montserrat", "region_id": 5 },
              { "id": 151, "name": "Nicaragua", "region_id": 5 },
              { "id": 152, "name": "Panama", "region_id": 5 },
              { "id": 153, "name": "Puerto Rico", "region_id": 5 },
              { "id": 154, "name": "Saint Barthélemy", "region_id": 5 },
              { "id": 155, "name": "Saint Kitts and Nevis", "region_id": 5 },
              { "id": 156, "name": "Saint Lucia", "region_id": 5 },
              { "id": 157, "name": "Saint Martin (French part)", "region_id": 5 },
              { "id": 158, "name": "Saint Pierre and Miquelon", "region_id": 5 },
              { "id": 159, "name": "Saint Vincent and the Grenadines", "region_id": 5 },
              { "id": 160, "name": "Trinidad and Tobago", "region_id": 5 },
              { "id": 161, "name": "Turks and Caicos Islands", "region_id": 5 },
              { "id": 162, "name": "U.S. Virgin Islands", "region_id": 5 },
              { "id": 163, "name": "United States", "region_id": 5 }
            ]
          },
          {
            "id": 6,
            "name": "Oceania",
            "value": "oceania",
            "countries": [
              { "id": 164, "name": "American Samoa", "region_id": 6 },
              { "id": 165, "name": "Australia", "region_id": 6 },
              { "id": 166, "name": "Cook Islands", "region_id": 6 },
              { "id": 167, "name": "Micronesia (Federated States of)", "region_id": 6 },
              { "id": 168, "name": "Fiji", "region_id": 6 },
              { "id": 169, "name": "French Polynesia", "region_id": 6 },
              { "id": 170, "name": "Guam", "region_id": 6 },
              { "id": 171, "name": "Kiribati", "region_id": 6 },
              { "id": 172, "name": "Marshall Islands", "region_id": 6 },
              { "id": 173, "name": "Nauru", "region_id": 6 },
              { "id": 174, "name": "New Caledonia", "region_id": 6 },
              { "id": 175, "name": "New Zealand", "region_id": 6 },
              { "id": 176, "name": "Niue", "region_id": 6 },
              { "id": 177, "name": "Norfolk Island", "region_id": 6 },
              { "id": 178, "name": "Northern Mariana Islands", "region_id": 6 },
              { "id": 179, "name": "Palau", "region_id": 6 },
              { "id": 180, "name": "Papua New Guinea", "region_id": 6 },
              { "id": 181, "name": "Pitcairn Islands", "region_id": 6 },
              { "id": 182, "name": "Samoa", "region_id": 6 },
              { "id": 183, "name": "Solomon Islands", "region_id": 6 },
              { "id": 184, "name": "Tokelau", "region_id": 6 },
              { "id": 185, "name": "Tonga", "region_id": 6 },
              { "id": 186, "name": "Tuvalu", "region_id": 6 },
              { "id": 187, "name": "United States Minor Outlying Islands", "region_id": 6 },
              { "id": 188, "name": "Vanuatu", "region_id": 6 },
              { "id": 189, "name": "Wallis and Futuna", "region_id": 6 }
            ]
          },
          {
            "id": 7,
            "name": "Africa",
            "value": "africa",
            "countries": [
              { "id": 190, "name": "Algeria", "region_id": 7 },
              { "id": 191, "name": "Angola", "region_id": 7 },
              { "id": 192, "name": "Benin", "region_id": 7 },
              { "id": 193, "name": "Botswana", "region_id": 7 },
              { "id": 194, "name": "Burkina Faso", "region_id": 7 },
              { "id": 195, "name": "Burundi", "region_id": 7 },
              { "id": 196, "name": "Cameroon", "region_id": 7 },
              { "id": 197, "name": "Cabo Verde", "region_id": 7 },
              { "id": 198, "name": "Central African Republic", "region_id": 7 },
              { "id": 199, "name": "Chad", "region_id": 7 },
              { "id": 200, "name": "Comoros", "region_id": 7 },
              { "id": 201, "name": "Republic of the Congo", "region_id": 7 },
              { "id": 202, "name": "Côte d'Ivoire", "region_id": 7 },
              { "id": 203, "name": "Democratic Republic of the Congo", "region_id": 7 },
              { "id": 204, "name": "Djibouti", "region_id": 7 },
              { "id": 205, "name": "Egypt", "region_id": 7 },
              { "id": 206, "name": "Equatorial Guinea", "region_id": 7 },
              { "id": 207, "name": "Eritrea", "region_id": 7 },
              { "id": 208, "name": "Ethiopia", "region_id": 7 },
              { "id": 209, "name": "Gabon", "region_id": 7 },
              { "id": 210, "name": "Gambia", "region_id": 7 },
              { "id": 211, "name": "Ghana", "region_id": 7 },
              { "id": 212, "name": "Guinea", "region_id": 7 },
              { "id": 213, "name": "Guinea-Bissau", "region_id": 7 },
              { "id": 214, "name": "Kenya", "region_id": 7 },
              { "id": 215, "name": "Lesotho", "region_id": 7 },
              { "id": 216, "name": "Liberia", "region_id": 7 },
              { "id": 217, "name": "Libya", "region_id": 7 },
              { "id": 218, "name": "Madagascar", "region_id": 7 },
              { "id": 219, "name": "Malawi", "region_id": 7 },
              { "id": 220, "name": "Mali", "region_id": 7 },
              { "id": 221, "name": "Mauritania", "region_id": 7 },
              { "id": 222, "name": "Mauritius", "region_id": 7 },
              { "id": 223, "name": "Mayotte", "region_id": 7 },
              { "id": 224, "name": "Morocco", "region_id": 7 },
              { "id": 225, "name": "Mozambique", "region_id": 7 },
              { "id": 226, "name": "Namibia", "region_id": 7 },
              { "id": 227, "name": "Niger", "region_id": 7 },
              { "id": 228, "name": "Nigeria", "region_id": 7 },
              { "id": 229, "name": "Réunion", "region_id": 7 },
              { "id": 230, "name": "Rwanda", "region_id": 7 },
              { "id": 231, "name": "Saint Helena", "region_id": 7 },
              { "id": 232, "name": "São Tomé and Príncipe", "region_id": 7 },
              { "id": 233, "name": "Senegal", "region_id": 7 },
              { "id": 234, "name": "Seychelles", "region_id": 7 },
              { "id": 235, "name": "Sierra Leone", "region_id": 7 },
              { "id": 236, "name": "Somalia", "region_id": 7 },
              { "id": 237, "name": "South Africa", "region_id": 7 },
              { "id": 238, "name": "South Sudan", "region_id": 7 },
              { "id": 239, "name": "Sudan", "region_id": 7 },
              { "id": 240, "name": "Eswatini", "region_id": 7 },
              { "id": 241, "name": "Tanzania", "region_id": 7 },
              { "id": 242, "name": "Togo", "region_id": 7 },
              { "id": 243, "name": "Tunisia", "region_id": 7 },
              { "id": 244, "name": "Uganda", "region_id": 7 },
              { "id": 245, "name": "Western Sahara", "region_id": 7 },
              { "id": 246, "name": "Zambia", "region_id": 7 },
              { "id": 247, "name": "Zimbabwe", "region_id": 7 }
            ]
          }
        ];

        if (countryStateSelector) {
        const regionData = fullData.find(region => region.value === selectedContinent || region.name === selectedContinent);
          const countries = regionData ? regionData.countries.map(c => ({ value: c.name, label: getLocalizedCountryLabel(c.name) })) : [];
          
          countryStateSelector.setOptions(countries);
          countryStateSelector.setSelected('');
        }

        const selectWrapper = continentEl.closest('.partnership-form__select-wrapper');
        if (selectWrapper) {
          selectWrapper.classList.remove('partnership-form__select-wrapper--error');
          const errorElement = selectWrapper.querySelector('.partnership-form__select-error');
          if (errorElement) {
            errorElement.style.display = 'none';
          }
        }
      });
    }
    
    // 初始化 Country/State 选择器
    const countryStateEl = document.getElementById('countryState');
    if (countryStateEl && countryStateEl.selectorAPI) {
      countryStateSelector = countryStateEl.selectorAPI;
      // 初始时不设置选项，或者设置一个空的提示选项，等待大洲选择
      countryStateSelector.setOptions([]); 
      
      // 启用搜索功能 (通过 data-enable-search 属性已经在 liquid 中设置，或者这里强制设置)
      countryStateEl.setAttribute('data-enable-search', 'true');
      
      countryStateEl.addEventListener('selectorChanged', function() {
        const selectWrapper = countryStateEl.closest('.partnership-form__select-wrapper');
        if (selectWrapper) {
          selectWrapper.classList.remove('partnership-form__select-wrapper--error');
          const errorElement = selectWrapper.querySelector('.partnership-form__select-error');
          if (errorElement) {
            errorElement.style.display = 'none';
          }
        }
        
        // 当国家改变时，如果 zip code 有值，重新验证 zip code
        const zipCodeField = form.querySelector('input[name="zipCode"]');
        if (zipCodeField && zipCodeField.value && zipCodeField.value.trim()) {
          validateZipCode(zipCodeField);
        }
      });
    }
    
    function selectPartnershipCategory(categoryValue) {
      if (!partnershipCategorySelector || !categoryValue) return false;
      const normalizedValue = normalizeComparisonValue(categoryValue);
      const matchedOption = partnershipCategoryOptions.find(function (opt) {
        return normalizeComparisonValue(opt.value) === normalizedValue
          || normalizeComparisonValue(opt.label) === normalizedValue;
      });

      if (!matchedOption) return false;

      partnershipCategorySelector.setSelected(matchedOption.value);
      setTimeout(function () {
        const event = new CustomEvent('selectorChanged', { detail: { value: matchedOption.value } });
        categoryEl.dispatchEvent(event);
      }, 100);

      return true;
    }

    function applyCategoryFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const categoryParam = urlParams.get('category');
      const wasApplied = selectPartnershipCategory(categoryParam);
      if (!wasApplied) return false;

      activeFormCategory = partnershipCategorySelector.getSelected() || activeFormCategory;
      syncPartnerTabs(activeFormCategory);
      updatePartnershipHeader(activeFormCategory);
      return true;
    }

    function applyDefaultCategoryFromActiveTab() {
      const defaultCategory = getActivePartnerCategory();
      activeFormCategory = defaultCategory || activeFormCategory;
      syncPartnerTabs(activeFormCategory);
      selectPartnershipCategory(defaultCategory);
      updatePartnershipHeader(defaultCategory);
      return defaultCategory;
    }

    function applyRemotePartnershipFieldOptions(remoteOptions) {
      const preservedCategory = activeFormCategory || getActivePartnerCategory();
      const preservedState = captureTabFormState();

      if (remoteOptions && Array.isArray(remoteOptions.categoryDefinitions) && remoteOptions.categoryDefinitions.length) {
        setPartnershipCategoryDefinitions(remoteOptions.categoryDefinitions);
        if (partnershipCategorySelector) {
          partnershipCategorySelector.setOptions(partnershipCategoryOptions);
          partnershipCategorySelector.setSelected(preservedCategory);
        }
      }

      if (remoteOptions && Array.isArray(remoteOptions.hearAboutUsOptions) && remoteOptions.hearAboutUsOptions.length) {
        hearAboutUsOptions = remoteOptions.hearAboutUsOptions.slice();
      }

      if (remoteOptions && Array.isArray(remoteOptions.yesNoOptions) && remoteOptions.yesNoOptions.length) {
        yesNoOptions = remoteOptions.yesNoOptions.slice();
      }

      renderPartnershipChoiceGroups();
      const restoreVersion = ++tabRestoreVersion;
      isRestoringTabState = true;
      selectPartnershipCategory(preservedCategory);
      setTimeout(function() {
        restoreTabFormState(preservedState, restoreVersion);
      }, 220);
    }

    function captureTabFormState() {
      const controls = Array.from(form.querySelectorAll('input[name], textarea[name], select[name]'))
        .filter(function(control) {
          return !control.closest('.component-input-selector')
            && !control.closest('[data-component="dialcode-selector"]');
        })
        .map(function(control) {
          return {
            name: control.name,
            type: control.type,
            optionValue: control.type === 'checkbox' || control.type === 'radio' ? control.value : '',
            value: control.value,
            checked: control.checked
          };
        });
      const dialcodeContainer = form.querySelector('[data-component="dialcode-selector"]');
      const dialcodeInstance = dialcodeContainer && window.DialCodeSelector
        ? window.DialCodeSelector.getInstance(dialcodeContainer)
        : null;

      return {
        controls: controls,
        selectors: {
          continent: continentSelector?.getSelected() || '',
          countryState: countryStateSelector?.getSelected() || '',
          subcategory: partnershipSubcategorySelector?.getSelected() || '',
          industries: industriesSelector?.getSelected() || '',
          sellingElectronic: getChoiceGroupSelectedValue(sellingElectronicSelector),
          sellingMobility: getChoiceGroupSelectedValue(sellingMobilitySelector)
        },
        dialcodeCountry: dialcodeInstance?.currentCountry || ''
      };
    }

    function restoreTabFormState(state, restoreVersion) {
      if (restoreVersion !== tabRestoreVersion) return;
      if (!state) {
        isRestoringTabState = false;
        return;
      }

      const controls = Array.from(form.querySelectorAll('input[name], textarea[name], select[name]'))
        .filter(function(control) {
          return !control.closest('.component-input-selector')
            && !control.closest('[data-component="dialcode-selector"]');
        });
      controls.forEach(function(control) {
        const savedControl = state.controls.find(function(saved) {
          return saved.name === control.name
            && saved.type === control.type
            && saved.optionValue === (control.type === 'checkbox' || control.type === 'radio' ? control.value : '');
        });
        if (!savedControl) return;
        if (control.type === 'checkbox' || control.type === 'radio') {
          control.checked = savedControl.checked;
        } else {
          control.value = savedControl.value;
        }
        control.dispatchEvent(new Event('input', { bubbles: true }));
      });

      const selectedContinent = state.selectors.continent;
      if (continentSelector) {
        continentSelector.setSelected(selectedContinent);
        continentEl.dispatchEvent(new CustomEvent('selectorChanged', { detail: { value: selectedContinent } }));
      }
      if (countryStateSelector) {
        countryStateSelector.setSelected(state.selectors.countryState);
      }
      if (partnershipSubcategorySelector) partnershipSubcategorySelector.setSelected(state.selectors.subcategory);
      if (industriesSelector) industriesSelector.setSelected(state.selectors.industries);
      setChoiceGroupSelectedValue(sellingElectronicSelector, state.selectors.sellingElectronic);
      setChoiceGroupSelectedValue(sellingMobilitySelector, state.selectors.sellingMobility);
      handleElectronicBrandSelection();
      handleMobilityBrandSelection();

      const dialcodeContainer = form.querySelector('[data-component="dialcode-selector"]');
      if (dialcodeContainer && window.DialCodeSelector) {
        const dialcodeInstance = window.DialCodeSelector.getInstance(dialcodeContainer);
        if (state.dialcodeCountry) {
          window.DialCodeSelector.setValue(dialcodeContainer, state.dialcodeCountry);
        } else if (dialcodeInstance) {
          dialcodeInstance.currentCountry = null;
          dialcodeInstance.isSelected = false;
          dialcodeInstance.updateDisplay();
        }
      }

      form.querySelectorAll('.component-text-input--error, .component-input-selector--error, .component-dialcode-selector--error')
        .forEach(function(element) {
          element.classList.remove('component-text-input--error', 'component-input-selector--error', 'component-dialcode-selector--error');
        });
      form.querySelectorAll('.component-dialcode-selector__error').forEach(function(element) {
        element.textContent = '';
        element.style.display = 'none';
      });
      form.querySelectorAll('.partnership-form__checkbox-error').forEach(function(element) {
        element.style.display = 'none';
      });
      form.querySelectorAll('.partnership-form__choice-group').forEach(function(element) {
        element.classList.remove('partnership-form__choice-group--error');
      });
      form.querySelectorAll('.partnership-form__choice-error').forEach(function(element) {
        element.textContent = '';
        element.style.display = 'none';
      });
      isRestoringTabState = false;
    }

    function switchTabFormState(nextCategory) {
      if (isPartnershipSubmitting || !nextCategory || nextCategory === activeFormCategory) return;

      const resultMessageEl = document.getElementById('partnershipResultMessage');
      if (resultMessageEl) {
        resultMessageEl.textContent = '';
        resultMessageEl.className = 'partnership-form__result-message';
        resultMessageEl.style.display = 'none';
      }

      if (!isRestoringTabState) tabFormStates[activeFormCategory] = captureTabFormState();
      activeFormCategory = nextCategory;
      const restoreVersion = ++tabRestoreVersion;
      isRestoringTabState = true;
      selectPartnershipCategory(nextCategory);

      setTimeout(function() {
        const stateToRestore = tabFormStates[nextCategory] || initialTabFormState;
        restoreTabFormState(stateToRestore, restoreVersion);
      }, 220);
    }

    // 初始化 Partnership Category 选择器（一级选项）
    const categoryEl = document.getElementById('partnershipCategory');
    if (categoryEl && categoryEl.selectorAPI) {
      partnershipCategorySelector = categoryEl.selectorAPI;
      partnershipCategorySelector.setOptions(partnershipCategoryOptions);
      
      // 监听选择变化
      categoryEl.addEventListener('selectorChanged', function(e) {
        const selectedValue = e.detail.value;
        
        // 清除一级选项的错误
        const selectWrapper = categoryEl.closest('.partnership-form__select-wrapper');
        if (selectWrapper) {
          selectWrapper.classList.remove('partnership-form__select-wrapper--error');
          const errorElement = selectWrapper.querySelector('.partnership-form__select-error');
          if (errorElement) {
            errorElement.style.display = 'none';
          }
        }
        
        // 重置所有条件字段
        partnershipSubcategoryField.style.display = 'none';
        resellerSpecificFields.style.display = 'none';
        resellerBasicFields.style.display = 'none';

        // Enterprise 分类时 Other Information 移到 Email 下方
        positionOtherInformationForCategory(selectedValue);

        // 清空二级选择器
        if (partnershipSubcategorySelector) {
          partnershipSubcategorySelector.setSelected('');
        }
        
        // 清空reseller特定字段
        const resellerInputs = resellerSpecificFields.querySelectorAll('input');
        resellerInputs.forEach(input => {
          input.value = '';
          if (window.hideTextInputError) {
            window.hideTextInputError(input);
          }
        });
        
        // 清空 Industries 选择器
        if (industriesSelector) {
          industriesSelector.setSelected('');
        }
        
        // 清空 Yes/No 下拉框
        setChoiceGroupSelectedValue(sellingElectronicSelector, '');
        setChoiceGroupSelectedValue(sellingMobilitySelector, '');
        handleElectronicBrandSelection();
        handleMobilityBrandSelection();
        
        // 清除条件字段错误
        const errorElements = document.querySelectorAll('.partnership-form__checkbox-error');
        errorElements.forEach(el => el.style.display = 'none');
        
        // 如果选择了有二级选项的分类，显示二级选项
        const subOptions = partnershipSubcategoryOptions[selectedValue];
        if (subOptions && subOptions.length > 0) {
          partnershipSubcategoryField.style.display = 'flex';
          
          // 关键修改：选择reseller后立即显示相关字段
          if (isResellerCategoryValue(selectedValue)) {
            resellerSpecificFields.style.display = 'flex';
            resellerBasicFields.style.display = 'flex';
            
            // 设置 Industries 为必填
            const industriesEl = document.getElementById('industries');
            if (industriesEl) {
              industriesEl.setAttribute('data-required', 'true');
            }

            // 设置reseller特定字段为必填 (Total Stores, Employees, Years)
            const specificInputs = resellerSpecificFields.querySelectorAll('.partnership-form__total-stores input, .partnership-form__total-employees input, .partnership-form__years-business input');
            specificInputs.forEach(input => {
              input.required = true;
            });
            
          } else {
            // 对于其他分类，移除reseller字段的必填属性
            
            // 移除 Industries 必填
            const industriesEl = document.getElementById('industries');
            if (industriesEl) {
              industriesEl.removeAttribute('data-required');
              if (industriesSelector) industriesSelector.clearError();
            }

            // 移除特定字段必填
            const specificInputs = resellerSpecificFields.querySelectorAll('.partnership-form__total-stores input, .partnership-form__total-employees input, .partnership-form__years-business input');
            specificInputs.forEach(input => {
              input.required = false;
              // 清除可能存在的错误状态
              if (window.hideTextInputError) window.hideTextInputError(input);
            });
            
          }
          
          // 初始化或更新二级选择器
          setTimeout(() => {
            const subcategoryEl = document.getElementById('partnershipSubcategory');
            if (subcategoryEl && subcategoryEl.selectorAPI) {
              partnershipSubcategorySelector = subcategoryEl.selectorAPI;
              partnershipSubcategorySelector.setOptions(subOptions);
              
              // 监听二级选项变化（只清空错误状态）
              if (subcategoryEl.dataset.partnershipSubcategoryTracked !== 'true') {
                subcategoryEl.dataset.partnershipSubcategoryTracked = 'true';
                subcategoryEl.addEventListener('selectorChanged', function() {
                  const subSelectWrapper = subcategoryEl.closest('.partnership-form__select-wrapper');
                  if (subSelectWrapper) {
                    subSelectWrapper.classList.remove('partnership-form__select-wrapper--error');
                    const errorElement = subSelectWrapper.querySelector('.partnership-form__select-error');
                    if (errorElement) {
                      errorElement.style.display = 'none';
                    }
                  }
                });
              }
            }
          }, 50);
        } else {
          // 如果没有选择任何选项，移除reseller字段的必填属性
          
          // 移除 Industries 必填
          const industriesEl = document.getElementById('industries');
          if (industriesEl) {
            industriesEl.removeAttribute('data-required');
            if (industriesSelector) industriesSelector.clearError();
          }

          // 移除特定字段必填
          const specificInputs = resellerSpecificFields.querySelectorAll('.partnership-form__total-stores input, .partnership-form__total-employees input, .partnership-form__years-business input');
          specificInputs.forEach(input => {
            input.required = false;
            if (window.hideTextInputError) window.hideTextInputError(input);
          });
          
        }
      });

      document.addEventListener('partnerCategoryChange', function (event) {
        const nextCategory = event.detail && event.detail.category;
        if (!nextCategory) return;
        syncPartnerTabs(nextCategory);
        updatePartnershipHeader(nextCategory);
        switchTabFormState(nextCategory);
      });
      
      if (!applyCategoryFromUrl()) applyDefaultCategoryFromActiveTab();
      setTimeout(function() {
        initialTabFormState = captureTabFormState();
        tabFormStates[activeFormCategory] = captureTabFormState();
      }, 250);
    }
    
    // 初始化 Industries 选择器
    const industriesEl = document.getElementById('industries');
    if (industriesEl && industriesEl.selectorAPI) {
      industriesSelector = industriesEl.selectorAPI;
      industriesSelector.setOptions(industriesOptions);
      
      industriesEl.addEventListener('selectorChanged', function() {
        const selectWrapper = industriesEl.closest('.partnership-form__select-wrapper');
        if (selectWrapper) {
          selectWrapper.classList.remove('partnership-form__select-wrapper--error');
          const errorElement = selectWrapper.querySelector('.partnership-form__select-error');
          if (errorElement) {
            errorElement.style.display = 'none';
          }
        }
      });
    }

    fetchPartnershipFieldOptions()
      .then(function (remoteOptions) {
        applyRemotePartnershipFieldOptions(remoteOptions);
      })
      .catch(function (error) {
        console.warn('Failed to load partnership field options:', error);
      });
    
    // 修复单选逻辑函数
    function setupExclusiveSelectionGroup(container) {
      if (!container) return;
      
      // 找到所有radio或checkbox
      const radios = container.querySelectorAll('.component-list-item__trailing-radio-input');
      const checkboxes = container.querySelectorAll('.component-list-item__trailing-checkbox-input');
      const inputs = radios.length > 0 ? radios : checkboxes;
      const listItems = container.querySelectorAll('.component-list-item');
      
      if (inputs.length === 0) return;
      
      // 为每个list item添加点击事件
      listItems.forEach((item, index) => {
        const input = inputs[index];
        if (!input) return;
        
        // 点击item时切换input状态
        item.addEventListener('click', function(e) {
          if (e.target === input || e.target.tagName === 'INPUT') return;
          
          // 如果是radio，直接选中当前项
          if (input.type === 'radio') {
            input.checked = true;
          } else {
            // 如果是checkbox，切换状态
            input.checked = !input.checked;
          }
          
          // 触发change事件
          const changeEvent = new Event('change', { bubbles: true });
          input.dispatchEvent(changeEvent);
        });
      });
      
      // 为radio设置互斥逻辑
      if (inputs[0].type === 'radio') {
        inputs.forEach(input => {
          input.addEventListener('change', function() {
            if (this.checked) {
              // 取消选中其他radio
              inputs.forEach(inp => {
                if (inp !== this) {
                  inp.checked = false;
                }
              });
              
              // 清除错误提示
              const errorEl = container.closest('.partnership-form__row')?.querySelector('.partnership-form__checkbox-error');
              if (errorEl) {
                errorEl.style.display = 'none';
              }
            }
          });
        });
      }
      
      // 为checkbox添加change事件监听错误清除
      inputs.forEach(input => {
        input.addEventListener('change', function() {
          const errorEl = container.closest('.partnership-form__row')?.querySelector('.partnership-form__checkbox-error');
          if (errorEl) {
            errorEl.style.display = 'none';
          }
        });
      });
    }
    
    // 修复多选组（How did you hear about us）
    function setupMultiSelectGroup(container) {
      if (!container) return;
      
      const checkboxes = container.querySelectorAll('.component-list-item__trailing-checkbox-input');
      const listItems = container.querySelectorAll('.component-list-item');
      
      if (checkboxes.length === 0) return;
      
      // 为每个list item添加点击事件
      listItems.forEach((item, index) => {
        const checkbox = checkboxes[index];
        if (!checkbox) return;
        
        item.addEventListener('click', function(e) {
          if (e.target === checkbox || e.target.tagName === 'INPUT') return;
          
          // 切换checkbox状态
          checkbox.checked = !checkbox.checked;
          
          // 触发change事件
          const changeEvent = new Event('change', { bubbles: true });
          checkbox.dispatchEvent(changeEvent);
        });
      });
      
      // 为每个checkbox添加change事件监听
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
          const errorEl = container.closest('.partnership-form__row')?.querySelector('.partnership-form__checkbox-error');
          if (errorEl) {
            errorEl.style.display = 'none';
          }
        });
      });
    }
    
    // 为单选组设置事件监听
    const sellingElectronicSelector = document.getElementById('sellingElectronic');
    const sellingMobilitySelector = document.getElementById('sellingMobility');
    const electronicBrandInput = document.getElementById('electronicBrandInput');
    const mobilityBrandInput = document.getElementById('mobilityBrandInput');
    const electronicChoiceError = sellingElectronicSelector
      ? sellingElectronicSelector.parentElement?.querySelector('[data-choice-error]')
      : null;
    const mobilityChoiceError = sellingMobilitySelector
      ? sellingMobilitySelector.parentElement?.querySelector('[data-choice-error]')
      : null;

    function getChoiceGroupSelectedValue(container) {
      if (!container) return '';
      const checkedInput = container.querySelector('.partnership-form__choice-input:checked');
      return checkedInput ? checkedInput.value : '';
    }

    function refreshChoiceGroupState(container) {
      if (!container) return;
      container.querySelectorAll('.partnership-form__choice-card').forEach(function(card) {
        const input = card.querySelector('.partnership-form__choice-input');
        card.classList.toggle('is-selected', Boolean(input && input.checked));
      });
    }

    function setChoiceGroupSelectedValue(container, value) {
      if (!container) return;
      const normalizedValue = String(value || '').toUpperCase();
      let matched = false;
      container.querySelectorAll('.partnership-form__choice-input').forEach(function(input) {
        const isMatch = normalizedValue !== '' && String(input.value || '').toUpperCase() === normalizedValue;
        input.checked = isMatch;
        if (isMatch) matched = true;
      });
      if (!matched && normalizedValue === '') {
        container.querySelectorAll('.partnership-form__choice-input').forEach(function(input) {
          input.checked = false;
        });
      }
      refreshChoiceGroupState(container);
      hideChoiceGroupError(container);
    }

    function showChoiceGroupError(container, errorElement) {
      if (!container) return;
      container.classList.add('partnership-form__choice-group--error');
      if (errorElement) {
        errorElement.textContent = validationMessages.fieldRequired || 'This field is required';
        errorElement.style.display = 'block';
      }
    }

    function hideChoiceGroupError(container) {
      if (!container) return;
      container.classList.remove('partnership-form__choice-group--error');
      const errorElement = container.parentElement?.querySelector('[data-choice-error]');
      if (errorElement) {
        errorElement.textContent = '';
        errorElement.style.display = 'none';
      }
    }

    function getCheckedChoiceValues(container, inputSelector) {
      if (!container) return [];
      return Array.from(container.querySelectorAll(inputSelector))
        .filter(function (input) {
          return input.checked;
        })
        .map(function (input) {
          return input.closest('.component-list-item')?.getAttribute('value') || '';
        })
        .filter(Boolean);
    }

    function renderChoiceItem(option, name, inputType, isLast) {
      const choiceValue = escapeHtml(option && option.value);
      const choiceLabel = escapeHtml(option && option.label);
      const trailingClass = inputType === 'radio'
        ? 'component-list-item__trailing-radio'
        : 'component-list-item__trailing-checkbox';
      const inputClass = inputType === 'radio'
        ? 'component-list-item__trailing-radio-input'
        : 'component-list-item__trailing-checkbox-input';
      const customClass = inputType === 'radio'
        ? 'component-list-item__trailing-radio-custom'
        : 'component-list-item__trailing-checkbox-custom';
      const divider = isLast ? '' : '<div class="divider component-list-item__divider"></div>';

      return `
        <div class="list-item component-list-item component-list-item--enabled partnership-form__list-item" data-component="list-item" data-trailing-alignment="center" name="${escapeHtml(name)}" value="${choiceValue}">
          <div class="state-layer component-list-item__state-layer">
            <div class="content component-list-item__content" data-content-wrapper>
              <div class="headline component-list-item__headline">${choiceLabel}</div>
            </div>
            <div class="trailing-element component-list-item__trailing">
              <div class="${trailingClass}">
                <input
                  type="${inputType}"
                  class="${inputClass}"
                  name="${escapeHtml(name)}"
                  value="${choiceValue}"
                  aria-label="${choiceLabel}"
                >
                <div class="${customClass}"></div>
              </div>
            </div>
          </div>
          ${divider}
        </div>
      `;
    }

    function renderChoiceGroup(container, options, name, inputType) {
      if (!container) return;
      const optionList = Array.isArray(options) ? options : [];
      container.innerHTML = optionList.map(function (option, index) {
        return renderChoiceItem(option, name, inputType, index === optionList.length - 1);
      }).join('');
    }

    function renderPartnershipChoiceGroups() {
      if (sellingElectronicSelector) {
        sellingElectronicSelector.querySelectorAll('.partnership-form__choice-input').forEach(function(input) {
          input.addEventListener('change', function() {
            if (input.checked) {
              trackPartnershipInteraction(
                'partnership_select_selling_electronic',
                'choice',
                input.value,
                'partnership_form_basic_info'
              );
            }
            refreshChoiceGroupState(sellingElectronicSelector);
            hideChoiceGroupError(sellingElectronicSelector);
            handleElectronicBrandSelection();
          });
        });
        refreshChoiceGroupState(sellingElectronicSelector);
      }

      if (sellingMobilitySelector) {
        sellingMobilitySelector.querySelectorAll('.partnership-form__choice-input').forEach(function(input) {
          input.addEventListener('change', function() {
            if (input.checked) {
              trackPartnershipInteraction(
                'partnership_select_selling_mobility',
                'choice',
                input.value,
                'partnership_form_basic_info'
              );
            }
            refreshChoiceGroupState(sellingMobilitySelector);
            hideChoiceGroupError(sellingMobilitySelector);
            handleMobilityBrandSelection();
          });
        });
        refreshChoiceGroupState(sellingMobilitySelector);
      }

      handleElectronicBrandSelection();
      handleMobilityBrandSelection();
    }

    // 处理 Consumer Electronic Brand 选择
    function handleElectronicBrandSelection() {
      const selectedValue = getChoiceGroupSelectedValue(sellingElectronicSelector);
      const isYes = isAffirmativeValue(selectedValue);
      
      if (electronicBrandInput) {
        if (isYes) {
          electronicBrandInput.style.display = 'flex';
          const brandInput = electronicBrandInput.querySelector('input[name="electronicBrands"]');
          if (brandInput) {
            brandInput.required = true;
          }
        } else {
          electronicBrandInput.style.display = 'none';
          const brandInput = electronicBrandInput.querySelector('input[name="electronicBrands"]');
          if (brandInput) {
            brandInput.required = false;
            brandInput.value = '';
            if (window.hideTextInputError) {
              window.hideTextInputError(brandInput);
            }
          }
        }
      }
    }
    
    // 处理 Mobility Devices 选择
    function handleMobilityBrandSelection() {
      const selectedValue = getChoiceGroupSelectedValue(sellingMobilitySelector);
      const isYes = isAffirmativeValue(selectedValue);
      
      if (mobilityBrandInput) {
        if (isYes) {
          mobilityBrandInput.style.display = 'flex';
          const brandInput = mobilityBrandInput.querySelector('input[name="mobilityBrands"]');
          if (brandInput) {
            brandInput.required = true;
          }
        } else {
          mobilityBrandInput.style.display = 'none';
          const brandInput = mobilityBrandInput.querySelector('input[name="mobilityBrands"]');
          if (brandInput) {
            brandInput.required = false;
            brandInput.value = '';
            if (window.hideTextInputError) {
              window.hideTextInputError(brandInput);
            }
          }
        }
      }
    }
    
    renderPartnershipChoiceGroups();

    const otherInfoTextarea = document.getElementById('otherInformation');

    // Zip Code 验证函数（基于国家进行验证）
    function validateZipCode(zipCodeField) {
      if (!zipCodeField) return true;
      
      const zipCodeValue = zipCodeField.value?.trim() || '';
      
      // 检查长度限制
      if (zipCodeValue.length > 20) {
        if (window.showTextInputError) {
          window.showTextInputError('Max 20 characters', zipCodeField);
        }
        return false;
      }

      // 如果为空，清除错误（必填验证由 validateForm 处理）
      if (zipCodeValue.length === 0) {
        if (window.hideTextInputError) {
          window.hideTextInputError(zipCodeField);
        }
        return true;
      }

      // 获取选中的国家
      const selectedCountry = countryStateSelector ? countryStateSelector.getSelected() : '';
      let iso2 = '';
      
      if (selectedCountry && countryNameToISO2[selectedCountry]) {
        iso2 = countryNameToISO2[selectedCountry];
      }

      // 使用 validator 进行格式校验（基于国家的 ISO2 代码；兜底用 any）
      let isValid = true;
      if (window.validator && typeof window.validator.isPostalCode === 'function') {
        try {
          isValid = window.validator.isPostalCode(zipCodeValue, iso2 || 'any');
        } catch (e) {
          // locale 不支持时 fallback
          try {
            isValid = window.validator.isPostalCode(zipCodeValue, 'any');
          } catch (err) {
            isValid = true;
          }
        }
      }

      if (!isValid) {
        if (window.showTextInputError) {
          window.showTextInputError('Please enter a valid ZIP code', zipCodeField);
        }
        return false;
      }

      // 清除错误
      if (window.hideTextInputError) {
        window.hideTextInputError(zipCodeField);
      }
      return true;
    }

    // Name Validation Function (Reference from take-a-drive)
    function validateNameField(field) {
      if (!field) {
        return true;
      }
      const trimmedValue = (field.value || '').trim();

      // 空值：清除错误，不提示（由必填校验处理）
      if (!trimmedValue) {
        if (window.hideTextInputError) {
          window.hideTextInputError(field);
        } else if (window.TextInputComponent && typeof window.TextInputComponent.clearError === 'function') {
          window.TextInputComponent.clearError(field);
        }
        return true;
      }

      // 合法非空：清除错误（已移除字母校验）
      if (window.hideTextInputError) {
        window.hideTextInputError(field);
      } else if (window.TextInputComponent && typeof window.TextInputComponent.clearError === 'function') {
        window.TextInputComponent.clearError(field);
      }
      return true;
    }

    // Zip Code 长度验证（失焦验证，参考 take-a-drive）
    const zipCodeField = form.querySelector('input[name="zipCode"]');
    if (zipCodeField) {
      zipCodeField.addEventListener('blur', function (e) {
        // 检查是否点击了清除按钮或密码切换按钮，如果是则跳过验证
        const relatedTarget = e.relatedTarget;
        const isClickingButton = relatedTarget && (
          relatedTarget.closest('.component-text-input__clear-btn') ||
          relatedTarget.closest('.component-text-input__password-toggle') ||
          relatedTarget.closest('.component-text-input__password-icon')
        );
        
        if (isClickingButton) {
          return; // 不处理失焦逻辑
        }
        
        validateZipCode(zipCodeField);
      });
    }
    
    // 通用验证函数

    function scrollToFirstFormError() {
      const candidates = form.querySelectorAll('.component-text-input--error, .component-input-selector--error, .component-dialcode-selector--error, .component-country-selector--error, .partnership-form__choice-group--error, .partnership-form__select-wrapper--error, .customer-support-form__message-wrap--error, [aria-invalid="true"], input:invalid, textarea:invalid, select:invalid');
      let target;
      for (const candidate of candidates) {
        const visible = candidate.type === 'hidden' ? candidate.closest('.component-input-selector') : candidate;
        if (visible && visible.getClientRects().length && getComputedStyle(visible).visibility !== 'hidden' && !candidate.disabled) {
          target = visible;
          break;
        }
      }
      if (!target) return;
      const focusTarget = target.matches('input:not([type="hidden"]), textarea, select, button, [tabindex]')
        ? target : target.querySelector('input:not([type="hidden"]):not(:disabled), textarea:not(:disabled), select:not(:disabled), button:not(:disabled), [tabindex="0"]');
      focusTarget?.focus({ preventScroll: true });
      window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - 120), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    function validateForm(form) {
      let hasError = false;

      // 1. 验证所有可见的文本输入框
      const visibleInputs = Array.from(form.querySelectorAll('input, textarea')).filter(input => {
        // 排除隐藏的元素 (例如条件显示的字段)
        return input.offsetParent !== null && !input.disabled && !input.readOnly;
      });

      visibleInputs.forEach(input => {
        // 检查 HTML5 required 属性
        if (input.required && !input.value.trim()) {
          hasError = true;
          if (window.showTextInputError) {
            window.showTextInputError(validationMessages.fieldRequired, input);
          }
        }
        
        // 检查特定类型的格式错误 (如果已经有值)
        if (input.value.trim()) {
          // First Name / Last Name 校验
          if (input.name === 'firstName' || input.name === 'lastName') {
            if (!validateNameField(input)) {
              hasError = true;
            }
          }
          
          // Zip Code 校验
          if (input.name === 'zipCode') {
            if (!validateZipCode(input)) {
              hasError = true;
            }
          }
          
          // Email 校验（已在 component-text-input.js 中统一处理）
          // 这里只需要在提交时再次检查（双保险）
          // 注意：email 输入框的 type 会被转换为 text，需要通过 data-intended-type 判断
          const intendedType = input.getAttribute('data-intended-type');
          if (intendedType === 'email' || input.type === 'email') {
            let isValidEmail = false;
            const emailValue = input.value.trim();
            
            // 第一步：基础格式校验
            if (window.validator && typeof window.validator.isEmail === 'function') {
              isValidEmail = window.validator.isEmail(emailValue);
            } else {
              // Fallback 到正则表达式
              isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
            }
            
            // 第二步：使用 tldts 验证域名有效性
            if (isValidEmail && window.tldts) {
              try {
                const domain = emailValue.split('@')[1];
                if (domain) {
                  const parsed = window.tldts.parse(domain);
                  // 严格检查：
                  // 1. domain 和 publicSuffix 必须都存在
                  // 2. isIcann 或 isPrivate 必须为 true（确保是有效的 TLD）
                  if (!parsed.domain || !parsed.publicSuffix || 
                      (!parsed.isIcann && !parsed.isPrivate)) {
                    isValidEmail = false;
                  }
                }
              } catch (e) {
                // tldts 解析失败，保持基础校验结果
                console.warn('tldts parsing failed:', e);
              }
            }
            
            if (!isValidEmail) {
              hasError = true;
              if (window.showTextInputError) {
                window.showTextInputError(validationMessages.emailInvalid, input);
              }
            }
          }
          // 数字类型校验
          if (input.type === 'number') {
            const val = parseFloat(input.value);
            if (isNaN(val) || val < 0) {
              hasError = true;
               if (window.showTextInputError) {
                 window.showTextInputError(validationMessages.invalidNumber, input);
               }
            }
          }
        }
      });

      // 2. 验证所有可见的选择器 (Input Selector)
      const visibleSelectors = Array.from(form.querySelectorAll('.component-input-selector')).filter(selector => {
        return selector.offsetParent !== null;
      });

      visibleSelectors.forEach(selector => {
        // 检查是否必填 (data-required="true")
        if (selector.hasAttribute('data-required') || selector.getAttribute('data-required') === 'true') {
          if (selector.selectorAPI && typeof selector.selectorAPI.validate === 'function') {
             const isValid = selector.selectorAPI.validate();
             if (!isValid) {
               hasError = true;
             }
          } else {
             // Fallback if no validate API (should not happen for component-input-selector)
             const hiddenInput = selector.querySelector('input[type="hidden"]');
             if (!hiddenInput || !hiddenInput.value) {
               hasError = true;
             }
          }
        }
      });

      // 2.5 验证 Yes/No 单选组
      const visibleChoiceGroups = Array.from(form.querySelectorAll('.partnership-form__choice-group[data-required="true"]')).filter(function(group) {
        return group.offsetParent !== null;
      });

      visibleChoiceGroups.forEach(function(group) {
        if (!getChoiceGroupSelectedValue(group)) {
          hasError = true;
          showChoiceGroupError(group, group.parentElement?.querySelector('[data-choice-error]'));
        } else {
          hideChoiceGroupError(group);
        }
      });

      // 3. 验证 Phone Number (使用组件自带验证)
      const phoneGroup = form.querySelector('[data-component="phone-with-dialcode"]');
      if (phoneGroup && phoneGroup.offsetParent !== null) {
         if (window.PhoneWithDialcode && window.PhoneWithDialcode.validate) {
           if (!window.PhoneWithDialcode.validate(phoneGroup)) {
             hasError = true;
           }
         }
      }
      
      // 4. 验证品牌输入框（当显示时必填）
      const electronicBrandInput = document.getElementById('electronicBrandInput');
      if (electronicBrandInput && electronicBrandInput.style.display !== 'none') {
        const brandInput = electronicBrandInput.querySelector('input[name="electronicBrands"]');
        if (brandInput && brandInput.required && !brandInput.value.trim()) {
          hasError = true;
          if (window.showTextInputError) {
            window.showTextInputError(validationMessages.fieldRequired, brandInput);
          }
        }
      }
      
      const mobilityBrandInput = document.getElementById('mobilityBrandInput');
      if (mobilityBrandInput && mobilityBrandInput.style.display !== 'none') {
        const brandInput = mobilityBrandInput.querySelector('input[name="mobilityBrands"]');
        if (brandInput && brandInput.required && !brandInput.value.trim()) {
          hasError = true;
          if (window.showTextInputError) {
            window.showTextInputError(validationMessages.fieldRequired, brandInput);
          }
        }
      }

      return !hasError;
    }

    // 表单提交
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      let hasTrackedSubmissionOutcome = false;
      const trackSubmissionOutcome = function(eventName, failureType) {
        if (hasTrackedSubmissionOutcome) return;
        hasTrackedSubmissionOutcome = true;
        trackPartnershipClarityEvent(eventName, failureType);
      };
      
      // 1. 执行通用验证
      let isValid = validateForm(form);

      if (!isValid) {
        trackSubmissionOutcome('partnership_form_failure', 'validation');
        scrollToFirstFormError();
        return;
      }
      
      const submitBtn = form.querySelector('.partnership-form__submit button, .partnership-form__submit');
      const resultMessageEl = document.getElementById('partnershipResultMessage');
      
      // 收集表单数据
      const dialCode = form.querySelector('input[name="dialcode"]')?.value.trim() || '';
      const phoneNum = form.querySelector('input[name="phoneNumber"]')?.value.trim() || '';
      
      const payload = {
        firstName: form.querySelector('input[name="firstName"]')?.value.trim() || '',
        lastName: form.querySelector('input[name="lastName"]')?.value.trim() || '',
        jobPosition: form.querySelector('input[name="jobPosition"]')?.value.trim() || '',
        mobile: (dialCode && phoneNum) ? (dialCode + '-' + phoneNum) : (dialCode || phoneNum),
        email: form.querySelector('input[name="email"]')?.value.trim() || '',
        zipCode: form.querySelector('input[name="zipCode"]')?.value.trim() || '',
        companyAddress: form.querySelector('input[name="address"]')?.value.trim() || '',
        companyWebsite: form.querySelector('input[name="website"]')?.value.trim() || '',
        companyName: form.querySelector('input[name="companyName"]')?.value.trim() || '',
        companyCountry: (() => {
          const selectedCountry = countryStateSelector ? countryStateSelector.getSelected() : '';
          // 将国家名称转换为国家码
          return selectedCountry ? (countryNameToISO2[selectedCountry] || selectedCountry) : '';
        })(),
        companyContinent: continentSelector ? continentSelector.getSelected() : '',
        partnershipFirstCategory: (() => {
          return partnershipCategorySelector ? partnershipCategorySelector.getSelected() : '';
        })(),
        partnershipSecondCategory: (() => {
          return partnershipSubcategorySelector ? partnershipSubcategorySelector.getSelected() : '';
        })(),
        industries: (() => {
          const selectedValues = industriesSelector ? industriesSelector.getSelected() : [];
          // 如果选中值不是数组（比如是空字符串或null），则返回空字符串
          if (!Array.isArray(selectedValues)) {
            // 如果是字符串且不为空，尝试返回它（可能是单选或已处理过）
            if (typeof selectedValues === 'string' && selectedValues) {
              // 如果是 "Others"，直接返回 "Others"
              if (selectedValues === 'Others') {
                return 'Others';
              }
              return selectedValues;
            }
            return '';
          }
          // 如果数组为空，返回空字符串
          if (selectedValues.length === 0) {
            return '';
          }
          // 将选中的 values 数组转换为 labels 数组，并用逗号连接成字符串
          const labels = selectedValues.map(val => {
            const option = industriesOptions.find(opt => opt.value === val);
            return option ? option.label : val;
          });
          const result = labels.join(', ');
          // 如果结果为空字符串，但 selectedValues 包含 "Others"，返回 "Others"
          if (!result && selectedValues.includes('Others')) {
            return 'Others';
          }
          return result;
        })(),
        totalStores: form.querySelector('input[name="totalStores"]')?.value || '',
        totalEmployees: form.querySelector('input[name="totalEmployees"]')?.value || '',
        yearsInBusiness: form.querySelector('input[name="yearsInBusiness"]')?.value || '',
        consumerElectronics: getChoiceGroupSelectedValue(sellingElectronicSelector),
        firstBrand: form.querySelector('input[name="electronicBrands"]')?.value.trim() || '',
        mobilityDevices: getChoiceGroupSelectedValue(sellingMobilitySelector),
        secondBrand: form.querySelector('input[name="mobilityBrands"]')?.value.trim() || '',
        otherInformation: otherInfoTextarea?.value.trim() || null
      };
      
      setSubmitButtonLoading(true);
      isPartnershipSubmitting = true;
      
      if (resultMessageEl) {
        resultMessageEl.textContent = '';
        resultMessageEl.className = 'partnership-form__result-message';
        resultMessageEl.style.display = 'none';
      }
      
      try {
        const response = await window.submitPartnershipForm(payload);
        
        // 检查是否是 postal code 相关的错误（无论 ok 是 true 还是 false）
        const backendMessage = response?.message || '';
        const isPostalCodeError = backendMessage && (
          backendMessage.includes('Invalid postal code') ||
          backendMessage.includes('Invalid ZIP code') ||
          backendMessage.includes('Please enter a valid ZIP') ||
          backendMessage.includes('Please enter a valid postal code') ||
          (backendMessage.toLowerCase().includes('zip') && backendMessage.toLowerCase().includes('postal code'))
        );
        
        // 如果是 postal code 错误，在输入框显示错误，不执行成功逻辑
        if (isPostalCodeError) {
          trackSubmissionOutcome('partnership_form_failure', response?.errorType || 'api');
          const zipCodeField = form.querySelector('input[name="zipCode"]');
          if (zipCodeField && window.showTextInputError) {
            window.showTextInputError(backendMessage, zipCodeField);
          }
          // 在按钮下方也显示错误消息
          if (resultMessageEl) {
            resultMessageEl.textContent = backendMessage;
            resultMessageEl.className = 'partnership-form__result-message partnership-form__result-message--error';
            resultMessageEl.style.display = 'block';
          }
          // 滚动到 zip code 输入框
          if (zipCodeField) {
            zipCodeField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          // 恢复提交按钮状态
          setSubmitButtonLoading(false);
          return;
        }
        
        if (response.ok) {
          trackSubmissionOutcome('partnership_form_success');
          const defaultCategoryAfterSubmit = getActivePartnerCategory();
          form.reset();
          
          const inputs = form.querySelectorAll('input, textarea');
          inputs.forEach(input => {
            if (window.hideTextInputError) {
              window.hideTextInputError(input);
            }
            // 使用 TextInputComponent 清除校验状态（会重置 label 位置等）
            if (window.TextInputComponent && window.TextInputComponent.clearValidationState) {
              window.TextInputComponent.clearValidationState(input);
            }
            // 移除所有状态类
            input.classList.remove('component-text-input__field--error');
            input.classList.remove('component-text-input__field--has-value');
            input.classList.remove('component-text-input__field--valid');
            const inputContainer = input.closest('.component-text-input');
            if (inputContainer) {
              inputContainer.classList.remove('component-text-input--error');
              inputContainer.classList.remove('component-text-input--invalid');
              inputContainer.classList.remove('component-text-input--valid');
              inputContainer.classList.remove('component-text-input--validating');
            }
            // 触发 input 事件以更新状态
            input.dispatchEvent(new Event('input', { bubbles: true }));
          });
          
          if (continentSelector) {
            continentSelector.setSelected('');
            // 移除展开状态
            const continentEl = document.getElementById('continent');
            if (continentEl) {
              continentEl.classList.remove('expanded');
              // 确保清除内联样式，交还给 CSS 类控制
              const dropdown = continentEl.querySelector('.component-input-selector__dropdown');
              if (dropdown) dropdown.style.display = '';
            }
          }
          if (countryStateSelector) {
            countryStateSelector.setSelected('');
            countryStateSelector.setOptions([]); // 清空国家选项，等待重新选择大洲
            
            // 移除展开状态
            const countryEl = document.getElementById('countryState');
            if (countryEl) {
              countryEl.classList.remove('expanded');
              // 确保清除内联样式，交还给 CSS 类控制
              const dropdown = countryEl.querySelector('.component-input-selector__dropdown');
              if (dropdown) dropdown.style.display = '';
            }
          }
          if (partnershipCategorySelector) partnershipCategorySelector.setSelected('');
          if (partnershipSubcategorySelector) partnershipSubcategorySelector.setSelected('');
          if (industriesSelector) industriesSelector.setSelected('');
          
          partnershipSubcategoryField.style.display = 'none';
          resellerSpecificFields.style.display = 'none';
          resellerBasicFields.style.display = 'none';
          
          const allRadios = form.querySelectorAll('.component-list-item__trailing-radio-input');
          const allCheckboxes = form.querySelectorAll('.component-list-item__trailing-checkbox-input');
          allRadios.forEach(rd => rd.checked = false);
          allCheckboxes.forEach(cb => cb.checked = false);
          setChoiceGroupSelectedValue(sellingElectronicSelector, '');
          setChoiceGroupSelectedValue(sellingMobilitySelector, '');
          
          // 清空品牌输入框并隐藏
          const electronicBrandInput = document.getElementById('electronicBrandInput');
          if (electronicBrandInput) {
            electronicBrandInput.style.display = 'none';
            const brandInput = electronicBrandInput.querySelector('input[name="electronicBrands"]');
            if (brandInput) {
              brandInput.value = '';
              brandInput.required = false;
              if (window.hideTextInputError) {
                window.hideTextInputError(brandInput);
              }
            }
          }
          
          const mobilityBrandInput = document.getElementById('mobilityBrandInput');
          if (mobilityBrandInput) {
            mobilityBrandInput.style.display = 'none';
            const brandInput = mobilityBrandInput.querySelector('input[name="mobilityBrands"]');
            if (brandInput) {
              brandInput.value = '';
              brandInput.required = false;
              if (window.hideTextInputError) {
                window.hideTextInputError(brandInput);
              }
            }
          }
          
          const phoneGroup = form.querySelector('[data-component="phone-with-dialcode"]');
          if (phoneGroup) {
            const dialcodeContainer = phoneGroup.querySelector('[data-component="dialcode-selector"]');
            if (dialcodeContainer && window.DialCodeSelector) {
              const instance = window.DialCodeSelector.getInstance(dialcodeContainer);
              if (instance) {
                if (instance.isDropdownOpen) {
                  instance.closeDropdown();
                }
                instance.isSelected = false;
                instance.currentCountry = instance.container.getAttribute('data-default-country') || 'US';
                instance.updateDisplay();
              }
              dialcodeContainer.classList.remove('component-dialcode-selector--error');
              const dialcodeErrorElement = dialcodeContainer.querySelector('.component-dialcode-selector__error');
              if (dialcodeErrorElement) {
                dialcodeErrorElement.style.display = 'none';
              }
            }
          }

          if (defaultCategoryAfterSubmit) {
            applyDefaultCategoryFromActiveTab();
          }
          
          if (resultMessageEl) {
            resultMessageEl.textContent = response?.message || 'Thank you for your partnership request. We will contact you soon.';
            resultMessageEl.className = 'partnership-form__result-message partnership-form__result-message--success';
            resultMessageEl.style.display = 'block';
          }
        } else {
          trackSubmissionOutcome('partnership_form_failure', response?.errorType || 'api');
          const backendMessage = response?.message || 'Submission failed. Please try again.';
          
          // 检查是否是 postal code 相关的错误
          const isPostalCodeError = backendMessage && (
            backendMessage.includes('Invalid postal code') ||
            backendMessage.includes('Invalid ZIP code') ||
            backendMessage.includes('Please enter a valid ZIP') ||
            backendMessage.includes('Please enter a valid postal code') ||
            (backendMessage.toLowerCase().includes('zip') && backendMessage.toLowerCase().includes('postal code'))
          );
          
          if (isPostalCodeError) {
            // 在 zip code 输入框显示错误
            const zipCodeField = form.querySelector('input[name="zipCode"]');
            if (zipCodeField && window.showTextInputError) {
              window.showTextInputError(backendMessage, zipCodeField);
            }
            // 在按钮下方也显示错误消息
            if (resultMessageEl) {
              resultMessageEl.textContent = backendMessage;
              resultMessageEl.className = 'partnership-form__result-message partnership-form__result-message--error';
              resultMessageEl.style.display = 'block';
            }
            // 滚动到 zip code 输入框
            if (zipCodeField) {
              zipCodeField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            // 恢复提交按钮状态
            setSubmitButtonLoading(false);
          } else {
            // 其他错误显示在 resultMessageEl
            if (resultMessageEl) {
              resultMessageEl.textContent = backendMessage;
              resultMessageEl.className = 'partnership-form__result-message partnership-form__result-message--error';
              resultMessageEl.style.display = 'block';
            }
          }
        }
      } catch (error) {
        trackSubmissionOutcome('partnership_form_failure', 'network');
        const errorMessage = error?.message || 'Submission failed. Please try again.';
        
        // 检查是否是 postal code 相关的错误
        const isPostalCodeError = errorMessage && (
          errorMessage.includes('Invalid postal code') ||
          errorMessage.includes('Invalid ZIP code') ||
          errorMessage.includes('Please enter a valid ZIP') ||
          errorMessage.includes('Please enter a valid postal code') ||
          (errorMessage.toLowerCase().includes('zip') && errorMessage.toLowerCase().includes('postal code'))
        );
        
        if (isPostalCodeError) {
          // 在 zip code 输入框显示错误
          const zipCodeField = form.querySelector('input[name="zipCode"]');
          if (zipCodeField && window.showTextInputError) {
            window.showTextInputError(errorMessage, zipCodeField);
          }
          // 在按钮下方也显示错误消息
          if (resultMessageEl) {
            resultMessageEl.textContent = errorMessage;
            resultMessageEl.className = 'partnership-form__result-message partnership-form__result-message--error';
            resultMessageEl.style.display = 'block';
          }
          // 滚动到 zip code 输入框
          if (zipCodeField) {
            zipCodeField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          // 恢复提交按钮状态
          setSubmitButtonLoading(false);
        } else {
          // 其他错误显示在 resultMessageEl
          if (resultMessageEl) {
            resultMessageEl.textContent = errorMessage;
            resultMessageEl.className = 'partnership-form__result-message partnership-form__result-message--error';
            resultMessageEl.style.display = 'block';
          }
        }
      } finally {
        isPartnershipSubmitting = false;
        setSubmitButtonLoading(false);
      }
    });
  }
});
